import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup
} from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import useBatchUploader from '../hooks/useBatchUploader'
import { useState, ChangeEvent } from 'react'

const ImportTrackingNumbers = () => {
  const [disableEmail, setDisableEmail] = useState(false)
  const { uploading, uploadTrackingNumbers } = useBatchUploader()

  const handleFileUpload = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return

    uploadTrackingNumbers(e.target.files[0], disableEmail)
  }

  return (
    <Box sx={{ p: 1, maxWidth: 'sm', m: '0 auto' }}>
      <FormGroup>
        <FormControlLabel
          control={<Checkbox />}
          label="Disable email notifications after import"
          onChange={(_, checked) => setDisableEmail(checked)}
        />
        <Button
          disabled={uploading}
          component="label"
          variant="contained"
          startIcon={<CloudUploadIcon />}
          sx={{ minHeight: 50 }}
        >
          Import Tracking Numbers
          <input
            type="file"
            accept="text/csv"
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
        </Button>
      </FormGroup>
    </Box>
  )
}

export default ImportTrackingNumbers
